export default function Testimonials() {
  return (
    <section className="bg-white py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className="flex justify-center mb-8">
          <img 
            src="https://kajabi-storefronts-production.kajabi-cdn.com/kajabi-storefronts-production/file-uploads/themes/2160880265/settings_images/aa73b-d423-ef26-5424-f574e4638d4_c821fd2-60ad-dfbb-b7b-3c7076dbb748_0a9554db-dfc8-42b5-bbf2-fe0e7fe8eafe.webp" 
            alt="Icon" 
            className="h-16"
          />
        </div>

        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900">What Students Are Saying...</h2>
        </div>

        {/* Testimonials */}
        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          <div>
            <img 
              src="https://kajabi-storefronts-production.kajabi-cdn.com/kajabi-storefronts-production/file-uploads/themes/2161209157/settings_images/acb2dda-87c4-77dc-cec8-274321dba42_test_5.png" 
              alt="Student Testimonial" 
              className="w-full rounded-lg"
            />
          </div>
          <div>
            <img 
              src="https://kajabi-storefronts-production.kajabi-cdn.com/kajabi-storefronts-production/file-uploads/themes/2161209157/settings_images/34fc4ab-57b-3b5-57b-3415efa56144_Jenny_-_video_for_husband_rounded_.png" 
              alt="Student Testimonial" 
              className="w-full rounded-lg"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
